"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Small = exports.SmallCSS = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _typography = _interopRequireDefault(require("./typography.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SmallCSS = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 100%;\n  padding: ", ";\n"])), function (props) {
  return props.padding || "0 0.25em 0 0";
});
exports.SmallCSS = SmallCSS;

var Small = _styledComponents.default.small(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), SmallCSS, _typography.default);

exports.Small = Small;
var _default = Small;
exports.default = _default;